import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { AnalyticsFilter } from "@/types/analytics.types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { HTTPError } from "ky";

export const useGetAnalyticsFilterForJobsQuery = (
  jobId: string,
  options?: Omit<
    UseQueryOptions<
      AnalyticsFilter,
      HTTPError,
      AnalyticsFilter,
      ["analytics-filter-for-jobs", string]
    >,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["analytics-filter-for-jobs", jobId],
    queryFn: async () => {
      const res = await apiClient
        .get(ENDPOINTS.GET_ANALYTICS_JOB_FILTER(jobId))
        .json<AnalyticsFilter>();
      return res;
    },
    ...options,
  });
};
